var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#056050",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 25H15C13.6167 25 12.4375 24.5125 11.4625 23.5375C10.4875 22.5625 10 21.3833 10 20C10 18.6167 10.4875 17.4375 11.4625 16.4625C12.4375 15.4875 13.6167 15 15 15H19V17H15C14.1667 17 13.4583 17.2917 12.875 17.875C12.2917 18.4583 12 19.1667 12 20C12 20.8333 12.2917 21.5417 12.875 22.125C13.4583 22.7083 14.1667 23 15 23H19V25ZM16 21V19H24V21H16ZM21 25V23H25C25.8333 23 26.5417 22.7083 27.125 22.125C27.7083 21.5417 28 20.8333 28 20C28 19.1667 27.7083 18.4583 27.125 17.875C26.5417 17.2917 25.8333 17 25 17H21V15H25C26.3833 15 27.5625 15.4875 28.5375 16.4625C29.5125 17.4375 30 18.6167 30 20C30 21.3833 29.5125 22.5625 28.5375 23.5375C27.5625 24.5125 26.3833 25 25 25H21Z",
    fill: "#004AC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic-link.e785afa2012d2e94230b7ac52474ab36.svg";
export { ForwardRef as ReactComponent };